const sharedRoutes = {
  contactSupport: '/contact-support',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  settings: '/settings',
};

export default sharedRoutes;
